/* istanbul ignore file */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { STRINGS } from 'config';

const {
  REDUCERS: {
    FEATURE_FLAGS: { GET_FEATURE_FLAGS_REQUEST, GET_FEATURE_FLAGS_SUCCESS },
  },
} = STRINGS;

export interface FeatureFlags {
  SUMMARISER_EMIS_INTEGRATION_ENABLED: boolean;
  TEMP_SUMMARISER_SNOMED_ENABLED: boolean;
  SUMMARISER_COPILOT_ENABLED: boolean;
  SUMMARISER_SEND_FEEDBACK_ENABLED: boolean;
  AI_SNOMED_CODES_ENABLED: string[];
  SUMMARISER_TEMPLATE_MANAGER_ENABLED: boolean;
  ENABLE_SHOW_WELCOME_MODAL: boolean;
  TEMP_SUMMARISER_PAYMENT_ENABLED: boolean;
  SUMMARISER_SAVE_TRANSCRIPT_ENABLED: boolean;
  SUMMARISER_REFERRAL_BUTTON_ENABLED: boolean;
  SUMMARISER_MANUAL_SNOMED_ENABLED: boolean;
  SUMMARISER_SHOW_EMIS_WEB_TEMPLATE: boolean;
}

export const initialFeatureFlagsState: FeatureFlags = {
  SUMMARISER_EMIS_INTEGRATION_ENABLED: false,
  TEMP_SUMMARISER_SNOMED_ENABLED: false,
  SUMMARISER_COPILOT_ENABLED: false,
  SUMMARISER_SEND_FEEDBACK_ENABLED: false,
  AI_SNOMED_CODES_ENABLED: ['EMIS'],
  SUMMARISER_TEMPLATE_MANAGER_ENABLED: false,
  ENABLE_SHOW_WELCOME_MODAL: false,
  TEMP_SUMMARISER_PAYMENT_ENABLED: false,
  SUMMARISER_SAVE_TRANSCRIPT_ENABLED: false,
  SUMMARISER_REFERRAL_BUTTON_ENABLED: false,
  SUMMARISER_MANUAL_SNOMED_ENABLED: false,
  SUMMARISER_SHOW_EMIS_WEB_TEMPLATE: false,
};

export const featureFlagsReducer = (state: any, action: any) => {
  switch (action.type) {
    case GET_FEATURE_FLAGS_REQUEST:
      return initialFeatureFlagsState;
    case GET_FEATURE_FLAGS_SUCCESS:
      return { ...state, ...action.payload };
    default: {
      return state;
    }
  }
};
